export default "__VITE_ASSET__fY$ulJoH__"